import { randomId } from '@shared/utils/randomId.js';
import IconV2 from '@/components/v2/IconV2.jsx';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2.jsx';
import { HiMiniEllipsisHorizontal } from '@/components/react-icons/main';
import TableCell from './TableCell.jsx';

const TableRow = ({ data, columns, actions = [], onChange, onAction, onRowClick, select }) => {
  const id = randomId();

  return (
    <div className={`table-row ${onRowClick ? 'table-row-highlight' : ''}`} onClick={(event) => onRowClick?.(data, event)}>
      {columns
        .filter((c) => !!c?.width)
        .map((column, index) => (
          <TableCell key={index} column={column} value={data[column.key]} style={{ ...column.style, width: column.width }} onChange={(e) => onChange(column, data, e)} select={select} />
        ))}
      {actions?.length > 0 && (
        <div className={'table-cell actions-cell'}>
          <IconV2 icon={HiMiniEllipsisHorizontal} className={`light-medium actions-button ${id}`} />
          <FloatingSelectV2 triggers={[`.${id}`]} options={actions} onChange={(e) => onAction(data, e)} useSearch={false} />
        </div>
      )}
    </div>
  );
};

export default TableRow;
